<template>
  <section>
    <div class="border-radius-12 border-card overflow-hidden">
      <b-collapse animation="slide" aria-id="cardRejectedSm" :open="true">
        <template #trigger="props">
          <div
            class="card-header header is-flex is-align-items-center p-3"
            role="button"
            aria-controls="cardRejectedSm"
            :aria-expanded="props.open"
          >
            <div class="card-header-title">
              <div class="is-flex is-align-items-center">
                <img src="../../assets/img/penawaran-pending.png" alt="penawaran-ditolak" class="mr-3">
                <div>
                  <p class="averta-bold is-size-5 has-text-white">Penawaran Ditolak</p>
                  <p class="has-text-white">
                    {{ forConsultant
                      ? 'Site Manager menolak penawaran yang telah dikirimkan. Lakukan Check-In Pemeriksaan, lalu Update Penawaran untuk memperbaiki dan mengirim ulang ke Site Manager.'
                      : 'Penawaran ini telah ditolak dan menunggu perbaikan dari Konsultan Survey.' }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mr-4 btn-tutup is-flex is-align-items-center">
              <span>{{ props.open ? 'Tutup Detail' : 'Lihat Detail' }}</span>
              <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'"></b-icon>
            </div>
          </div>
        </template>

        <div class="card-content">
          <div class="content">
            <div class="is-flex is-align-items-center mb-3">
              <ChatIcon class="mr-3" />
              <div>
                <p class="mb-0 averta-bold">
                  Ditolak SM
                  <span class="text-grey averta-regular" v-if="smReject.rejected_by_name">
                    &middot; {{ smReject.rejected_by_name }}
                  </span>
                  <span class="text-grey averta-regular" v-if="smReject.created_at">
                    &middot; {{ convertDate(smReject.created_at) }}
                  </span>
                </p>
                <!-- pre-line: baris baru (Enter) yang diketik SM tetap tampil sebagai baris baru -->
                <p class="text-grey note-sm">{{ smReject.note || '-' }}</p>
                <p class="averta-bold label-16 mt-2" v-if="smReject.total > 1">
                  Penolakan ke-{{ smReject.total }} untuk penawaran ini
                </p>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { ChatIcon } from '../icons'

/*
  Banner untuk penawaran yang ditolak Site Manager (fitur SM Tolak Penawaran).
  Berbeda dari CardRejected.vue yang khusus penolakan client dan mengarah ke rute AM.
  Sumber data: dataPenawaran.sm_reject dari endpoint detail penawaran.
  Kartu ini hanya informasi; aksi konsultan lewat tombol Check-In Pemeriksaan lalu Update Penawaran di header.
*/
export default {
  name: 'CardRejectedSM',
  props: {
    dataPenawaran: {
      type: Object,
      default: () => ({})
    },
    // true untuk Konsultan Survey: teks kartu mengarahkan ke tombol Check-In Pemeriksaan
    forConsultant: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ChatIcon
  },
  computed: {
    smReject () {
      return (this.dataPenawaran && this.dataPenawaran.sm_reject) || {}
    }
  },
  methods: {
    convertDate (date) {
      return moment(date).format('DD MMMM YYYY, HH:mm')
    }
  }
}
</script>

<style scoped>
.header {
  background: linear-gradient(90deg, #891313 0%, #D92727 99.97%);
  border-radius: 12px 12px 0px 0px;
  color: white;
}

.btn-tutup {
  border: 1px solid white;
  padding: 12px 24px;
  border-radius: 24px;
  white-space: nowrap;
}

.text-grey {
  color: #868686;
}

.note-sm {
  white-space: pre-line;
  word-break: break-word;
}

</style>
